module.exports = __webpack_public_path__ + "static/media/08.3480e5f3.jpg";